import { Link } from "react-router-dom";
import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/subscribers", { email });
      toast.success(data.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="bg-[#2A2E2C] text-[#FAFAF8] mt-32">
      <div className="ccn-container py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-heading text-3xl mb-3">Stay in covenant.</div>
          <p className="text-white/70 max-w-md mb-6 leading-relaxed">
            Get sermon notes, prayer prompts, and live service reminders delivered to your inbox.
          </p>
          <form onSubmit={submit} className="flex gap-2 max-w-md" data-testid="footer-subscribe-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              data-testid="footer-subscribe-email"
              className="flex-1 px-5 py-3 rounded-full bg-white/10 border border-white/10 text-white placeholder-white/40 focus:outline-none focus:border-[#DDA754]"
            />
            <button
              type="submit"
              disabled={busy}
              data-testid="footer-subscribe-submit"
              className="px-6 py-3 rounded-full bg-[#DDA754] text-[#2A2E2C] font-medium hover:bg-[#e6b66a] transition disabled:opacity-60"
            >
              {busy ? "..." : "Subscribe"}
            </button>
          </form>
        </div>

        <div className="md:col-span-2">
          <div className="ccn-overline mb-4 text-[#DDA754]">Explore</div>
          <ul className="space-y-2.5">
            <li><Link to="/sermons" className="hover:text-[#DDA754]">Sermons</Link></li>
            <li><Link to="/live" className="hover:text-[#DDA754]">Watch Live</Link></li>
            <li><Link to="/give" className="hover:text-[#DDA754]">Give</Link></li>
            <li><Link to="/about" className="hover:text-[#DDA754]">About</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="ccn-overline mb-4 text-[#DDA754]">Connect</div>
          <ul className="space-y-2.5 text-white/80">
            <li>connect@christiancovenantnetwork.us</li>
            <li>Mondays · 7 PM CST / 8 PM EST</li>
            <li>Online &amp; Worldwide</li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="ccn-overline mb-4 text-[#DDA754]">Ministry</div>
          <ul className="space-y-2.5">
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="text-white/60 hover:text-[#DDA754]">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="ccn-container py-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="text-sm text-white/50">© {new Date().getFullYear()} Christian Covenant Network · All rights reserved</div>
          <div className="text-xs tracking-[0.2em] uppercase text-white/40">By grace · For glory</div>
        </div>
      </div>
    </footer>
  );
}
